<template>
    <vx-card class="sidebar-item overflow-hidden">
        <div class="vx-row item-details no-gutter">
            <div>{{item.name}}</div>
            <div class="ml-auto">
                 <vs-checkbox/>
            </div>
        </div>
    </vx-card>
</template>

<script>
    export default {
        name: 'sidebar-item',
        props: {
          item: {
              type: Object,
              required: true
          }
        }
    }
</script>
